import { COMPLETED_STATUSES, IN_PROGRESS_STATUSES, TERMINATED_STATUSES } from "../../utils/automation/bulk"
import { BulkOperationStatus } from "../../utils/automation/bulk"

type BulkOperationDtoAttributes = {
    id: string,
    accountId: string,
    operationType: string,
    createdBy: string,
    itemsCreated: number,
    totalItems: number,
    status: BulkOperationStatus,
    completedAt: string,
    updatedAt: string,
    createdAt: string,
    notificationLink: string,
    metadata,
}

export type BulkOperationDto = {
    id: string
    type: string
    attributes: BulkOperationDtoAttributes
}

export default class BulkOperation {
    private dto: BulkOperationDto

    constructor(dto: BulkOperationDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.getId() != "" && this.dto.type == "bulk-operations"
    }

    getId(): string {
        return this.dto.id
    }

    getBulkOperationStatus(): BulkOperationStatus {
        return this.dto.attributes.status
    }

    isCompleted(): boolean {
        return COMPLETED_STATUSES.includes(this.dto.attributes.status)
    }

    isInProgress(): boolean {
        return IN_PROGRESS_STATUSES.includes(this.dto.attributes.status)
    }

    isTerminated(): boolean {
        return TERMINATED_STATUSES.includes(this.dto.attributes.status)
    }

    setBulkOperationStatus(status: BulkOperationStatus) {
        this.dto.attributes.status = status
    }

    setBulkOperationUrl(notificationLink: string) {
        this.dto.attributes.notificationLink = notificationLink
    }

    getBulkOperationUrl(): string {
        return this.dto.attributes.notificationLink
    }

    getBulkOperationType(): string {
        return this.dto.attributes.operationType
    }

    getBulkOperationUpdatedAt(): Date {
        return new Date(this.dto.attributes.updatedAt)
    }

    getPercentageOfProgress(): number {
        const progress = (this.dto.attributes.itemsCreated * 100) / this.dto.attributes.totalItems
        if (progress == 0) {
            return 1
        }
        if (progress > 100) {
            return 100
        }
        return progress
    }
}


// WEBPACK FOOTER //
// ./src/state/bulk-operation/BulkOperation.ts